import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useQueryErrorResetBoundary } from 'react-query';
import { Redirect } from 'react-router-dom';

import { LOCATION_OFFLINE_PATH } from 'catering/constants/paths';
import logWarningOrError from 'logging/logWarningOrError';

function FallbackRender({ resetErrorBoundary }) {
  React.useEffect(() => {
    resetErrorBoundary();
  }, [resetErrorBoundary]);
  return <Redirect to={LOCATION_OFFLINE_PATH} />;
}

FallbackRender.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired
};

function ErrorBoundary(props) {
  const { reset } = useQueryErrorResetBoundary();

  const handleError = (error, info) => {
    logWarningOrError(error, info);
  };

  return (
    <ReactErrorBoundary
      onError={handleError}
      onReset={reset}
      fallbackRender={({ resetErrorBoundary }) => (
        <FallbackRender resetErrorBoundary={resetErrorBoundary} />
      )}
      {...props}
    />
  );
}

export default ErrorBoundary;
